import { render, staticRenderFns } from "./ISelect.vue?vue&type=template&id=fde06c0e"
import script from "./ISelect.vue?vue&type=script&lang=js"
export * from "./ISelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports